var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoldRank4(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gold_rank_4_svg__clip0_1947_7057)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gold_rank_4_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 199
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.865.333H0v198.193h200.865V.333z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gold_rank_4_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.334 38.63c-5.344-5.608-14.62-4.15-18.037 2.797-8.93 18.138-6.153 40.672 8.615 56.17 18.43 19.339 48.732 20.586 68.68 3.208L37.333 38.629z",
    fill: "#FAE185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.322 75.971C6.903 73.73-.439 79.571.024 87.296c1.201 20.181 14.761 38.402 35.265 44.594 25.585 7.726 52.553-6.134 61.308-31.085L14.322 75.971z",
    fill: "#F9DD74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.338 122.133c-7.507 1.926-10.76 10.723-6.358 17.091 11.497 16.64 32.546 25.208 53.291 19.894 25.89-6.631 41.771-32.443 36.315-58.313l-42.55 10.898-40.704 10.424.006.006z",
    fill: "#F9D862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.531 38.63c5.344-5.608 14.621-4.15 18.037 2.797 8.931 18.138 6.153 40.672-8.614 56.17-18.43 19.339-48.732 20.586-68.68 3.208l59.257-62.176z",
    fill: "#FAE185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.543 75.971c7.419-2.242 14.762 3.6 14.305 11.331-1.202 20.181-14.762 38.402-35.266 44.594-25.585 7.726-52.553-6.134-61.308-31.085l82.269-24.84z",
    fill: "#F9DD74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.522 122.133c7.507 1.926 10.759 10.723 6.358 17.091-11.497 16.64-32.547 25.208-53.291 19.894-25.89-6.631-41.77-32.443-36.315-58.313l42.55 10.898 40.704 10.424-.006.006z",
    fill: "#F9D862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.792.333h108.224c6.47 0 11.72 5.245 11.72 11.706v120.729c0 36.288-29.499 65.752-65.832 65.752-36.332 0-65.832-29.464-65.832-65.752V12.039c0-6.461 5.25-11.706 11.72-11.706z",
    fill: "#F8D451"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.195 67.824h75.413c4.506 0 8.169 3.652 8.169 8.159v49.346c0 25.29-20.557 45.817-45.873 45.817-25.321 0-45.872-20.532-45.872-45.817V75.983c0-4.501 3.657-8.16 8.169-8.16h-.006z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 70.165c3.211 0 5.825 2.61 5.825 5.818v49.346c0 23.974-19.526 43.476-43.529 43.476-24.002 0-43.528-19.502-43.528-43.476V75.983c0-3.208 2.613-5.818 5.825-5.818h75.413m0-2.341h-75.42c-4.511 0-8.168 3.652-8.168 8.159v49.346c0 25.302 20.54 45.817 45.872 45.817 25.333 0 45.873-20.515 45.873-45.817V75.983c0-4.507-3.657-8.16-8.169-8.16h.012z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.016.333h-44.982L35.072 75.204v51.582l125.3-125.153a11.673 11.673 0 00-5.356-1.3zM95.712 112.534l71.024-70.937v-29.23L81.079 97.92l14.633 14.614z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M102.223 23.453l2.033 6.25c.223.691.868 1.16 1.6 1.16h6.581c1.629 0 2.303 2.077.984 3.032l-5.321 3.862a1.68 1.68 0 00-.609 1.873l2.033 6.251c.504 1.545-1.265 2.833-2.584 1.873l-5.321-3.863a1.681 1.681 0 00-1.975 0l-5.32 3.863c-1.319.954-3.089-.328-2.585-1.873l2.034-6.25a1.68 1.68 0 00-.61-1.874l-5.32-3.862c-1.32-.955-.64-3.032.984-3.032h6.58c.727 0 1.372-.469 1.6-1.16l2.034-6.25c.504-1.545 2.69-1.545 3.194 0h-.012z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.223 23.453l2.033 6.25c.223.691.868 1.16 1.6 1.16h6.581c1.629 0 2.303 2.077.984 3.032l-5.32 3.862a1.678 1.678 0 00-.61 1.873l2.033 6.251c.504 1.545-1.265 2.833-2.584 1.873l-5.321-3.863a1.681 1.681 0 00-1.975 0l-5.32 3.863c-1.319.954-3.089-.328-2.585-1.873l2.034-6.25a1.68 1.68 0 00-.61-1.874l-5.32-3.862c-1.32-.955-.64-3.032.984-3.032h6.58c.727 0 1.372-.469 1.6-1.16l2.034-6.25c.504-1.545 2.69-1.545 3.194 0h-.012z",
    fill: "#22AEFC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gold_rank_4_svg__clip0_1947_7057"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h201v199H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldRank4);
export default ForwardRef;